import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories, categoryMap } from '@/mocks/categories';
import { getComicsByCategory } from '@/mocks/comics';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'romance');

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeCategory);
  const categoryComics = getComicsByCategory(activeCategory);
  const categoryName = categoryMap[activeCategory] || activeCategory;

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${categoryName}韩漫 - 韩漫之家`,
          description: `韩漫之家${categoryName}分类，汇集优质${categoryName}类韩国漫画，支持下拉式阅读，高清画质，极速更新。`,
        }}
      />
      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '漫画分类', href: '/category/romance' },
          { label: categoryName },
        ]}
      />

      <main className="max-w-7xl mx-auto px-4 md:px-6 pb-14">
        <div className="mb-8">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {categoryName}
          </h1>
          <p className="text-sm text-foreground-500 mt-1">
            {currentCategory?.description || `浏览${categoryName}类韩国漫画`}
          </p>
        </div>

        <div className="flex items-center gap-2 mb-8 overflow-x-auto flex-wrap pb-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        {categoryComics.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {categoryComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500">该分类暂无漫画，请浏览其他分类</p>
            <Link to="/" className="inline-block mt-4 px-6 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
              返回首页
            </Link>
          </div>
        )}
      </main>
    </>
  );
}